import { useRef } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { Formik } from 'formik';

import { PlanPrefixTable } from '@components/Order/Numbers/Tables/PlanPrefixTable';
import { AutoScrollToElement } from '@features/AutoScrollTo';
import { hidePlanPrefixes, planDetailsApi } from '@reducers/plan/plan';
import { skipToken } from '@reduxjs/toolkit/query';

export const PlanPrefixesCard = () => {
  const dispatch = useDispatch();
  const prefixElem = useRef(null);
  const { showState } = useSelector((state) => state.plan.planInfo);
  const queryArg =
    showState.currentPlan.id && showState.currentPlan.type
      ? { ...showState.currentPlan }
      : skipToken;
  const [searchParams] = useSearchParams();

  return (
    <>
      <Card className="mt-2" ref={prefixElem}>
        <Card.Header className="bg-didxl text-white">
          Please select Prefix
        </Card.Header>
        <Card.Body>
          <Formik
            enableReinitialize
            initialValues={{
              prefix: searchParams.get('prefix') || '',
              prefixName: searchParams.get('prefixName') || '',
            }}
            onSubmit={() => {}}
          >
            <Form as={Row}>
              <Col md={6}>
                <PlanPrefixTable
                  useData={planDetailsApi.useGetPrefixesQuery}
                  useDataArgs={queryArg}
                  plan={showState.currentPlan}
                />
              </Col>
            </Form>
          </Formik>
          <Row>
            <Col>
              If you want to order DID’s in multiple Prefix area’s you can start
              with the first prefix and add DID’s in other prefixes after
              selecting and completing the order information for the first
              prefix.
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                variant="didxl"
                onClick={() => {
                  dispatch(hidePlanPrefixes());
                }}
                size="sm"
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <AutoScrollToElement block="start" ref={prefixElem} />
    </>
  );
};
